import angular from 'angular';
import Logger from '../shared/logger';
import UtilsService from './utilsService';

/**
 * @class ImpersonationService
 * Provide methods which helps getting actual data about current user
 * or data of the user which is current behalf-of.
 */
export function ImpersonationService($cookies, RecruiterService, permissions, Restangular) {
    /**
     * @function getCurrentTalentExpertRoleData
     * @return data of real recruiter user or recruiter which associated with Talenya user.
     */

    const getCurrentTalentExpertRoleData = async () => {
        UtilsService.cookiesOverride($cookies);
        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        const recruiterId = userPrefs?.entityId;
        const isTalentExpert = permissions.isTalentExpertUser();

        if (recruiterId && isTalentExpert) {
            try {
                const { result: recruiterData } = await RecruiterService.getRecruiter(recruiterId);

                return recruiterData;
            } catch (error) {
                Logger.error(error);
            }
        }

        return null;
    };

    /**
     * @function getOnBehalfOfTalentExpertRoleData
     * @return data of recruiter which is current user behalf of.
     */
    const getOnBehalfOfTalentExpertRoleData = async () => {
        try {
            const behalfOfData = JSON.parse(Restangular.configuration.defaultHeaders['on-behalf'] || null);
            const isTalentExpert = permissions.isTalentExpertUser();
            const behalfOfRecruiterId = behalfOfData && behalfOfData.recruiterId;
            const isUserBehalfOfTalentExpert = behalfOfRecruiterId && isTalentExpert;

            if (isUserBehalfOfTalentExpert) {
                const { result: recruiterData } = await RecruiterService.getRecruiter(behalfOfData.recruiterId);

                return recruiterData;
            }
        } catch (error) {
            Logger.error(error);
        }

        return null;
    };

    /**
     * @function getBehalfOfOrCurrentTalentExpertRoleData
     * @return data of recruiter which is user currently use.
     * If current user is behalf-of someone recruiter, then behalf-of recruiter data will be returned, else
     * data of real recruiter user or recruiter which associated with Talenya user.
     */
    const getBehalfOfOrCurrentTalentExpertRoleData = async () => {
        const isTalentExpert = permissions.isTalentExpertUser();

        if (isTalentExpert) {
            try {
                const behalfOfData = await getOnBehalfOfTalentExpertRoleData();

                return behalfOfData || getCurrentTalentExpertRoleData();
            } catch (error) {
                Logger.error(error);
            }
        }

        return null;
    };

    return {
        getBehalfOfOrCurrentTalentExpertRoleData,
    };
}

angular.module('TALENYA-FE').factory('ImpersonationService', ImpersonationService);
